<button
    [type]="buttonType()"
    [class]="classNames()"
    (click)="onClick()"
    [disabled]="disabled"
    [attr.aria-disabled]="disabled"
    [attr.aria-busy]="isBusy"
    [attr.aria-label]="iconOnly && !confirmationActive ? title || text : null"
    [class.w-full]="width === 'fill'"
    [class.align-right]="textAlign === 'right'"
    [class.align-left]="textAlign === 'left'"
    [class.is-busy]="isBusy"
    [title]="title"
    *ngIf="visible"
>
  <i
    class="fa-icon {{faIcon}}"
    [class.order-2]="iconPosition === 'right'"
    *ngIf="faIcon"
    aria-hidden="true"
  ></i>
  <span class="text" *ngIf="!iconOnly || confirmationActive" [attr.aria-live]="confirmationActive ? 'assertive' : null">
          {{ text }}
      </span>

  <span class="spinner" *ngIf="isBusy">
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  </span>

</button>
